import { FC } from 'react';
import cn from 'classnames';
import { GridRender } from '@base/snippets/GridRender';
import { contactList } from 'pro/config/contact';
import EmailLink from '@base/snippets/EmailLink';
import PhoneLink from '@base/snippets/PhoneLink';
import { isPhone } from 'base/utils/client';

type IProps = {
    className?: string;
}

export const ContactList: FC<IProps> = ({ className }) => {
    return (
        <GridRender
            className={cn(
                isPhone ? 'text-14' : 'text-18',
                className,
            )}
            list={contactList}
            colsPerRow={isPhone ? 1 : 2}
            gutter={isPhone ? 16 : [20, 24]}
            render={item => (
                <>
                    <p>{item.name}</p>
                    <p><EmailLink value={item.email}/></p>
                    <p><PhoneLink value={item.phone.url}>{item.phone.text}</PhoneLink></p>
                </>
            )}
        />
    )
};
